(function () {
  function pad(n) { return String(n).padStart(2, '0'); }

  function initCountdown(root) {
    if (!root) return;

    var targetRaw = root.getAttribute('data-countdown-target');
    var liveText = root.getAttribute('data-live-text') || 'Restock is live.';
    var target = targetRaw ? new Date(targetRaw) : null;

    var dEl = root.querySelector('[data-cd-days]');
    var hEl = root.querySelector('[data-cd-hours]');
    var mEl = root.querySelector('[data-cd-mins]');
    var sEl = root.querySelector('[data-cd-secs]');
    var msgEl = root.querySelector('[data-cd-message]');

    if (!target || isNaN(target.getTime()) || !dEl || !hEl || !mEl || !sEl) {
      if (msgEl) msgEl.textContent = '';
      return;
    }

    function set(el, val, isDays) {
      var text = isDays ? String(val) : pad(val);
      if (el.textContent !== text) {
        el.textContent = text;
        el.classList.add('tick');
        setTimeout(function () { el.classList.remove('tick'); }, 180);
      }
    }

    function tick() {
      var diff = target.getTime() - Date.now();

      if (diff <= 0) {
        set(dEl, 0, true);
        set(hEl, 0, false);
        set(mEl, 0, false);
        set(sEl, 0, false);
        if (msgEl) msgEl.textContent = liveText;
        return;
      }

      if (msgEl) msgEl.textContent = '';
      set(dEl, Math.floor(diff / 864e5), true);
      set(hEl, Math.floor((diff % 864e5) / 36e5), false);
      set(mEl, Math.floor((diff % 36e5) / 6e4), false);
      set(sEl, Math.floor((diff % 6e4) / 1e3), false);
    }

    tick();
    setInterval(tick, 1000);
  }

  function initAll() {
    document.querySelectorAll('[data-mavy-countdown]').forEach(initCountdown);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (event) {
    initCountdown(event.target.querySelector('[data-mavy-countdown]'));
  });
})();
